import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aee178fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  key: 0,
  class: "read-more__link"
}

import {computed, ref, watch} from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReadMore',
  props: {
        maxHeight: {type: Number, default: 180},
        dataTestid: {type: String, default: 'read-more-component'},
        viewMoreLabel: {type: String, required: true},
    },
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "54df8a4c": (maxHeightCssVariable)
}))

    

    const isReadMoreLinkVisible = ref(true);
    const readMoreContentElement = ref<HTMLElement>();
    const readMoreContentHeight = computed(() => readMoreContentElement.value?.scrollHeight || 0);
    const isHigherThanDefinedMaxHeight = computed(() => readMoreContentHeight.value > props.maxHeight);
    const maxHeightCssVariable = `${props.maxHeight}px`;

    watch(readMoreContentHeight, () => {
        isReadMoreLinkVisible.value = isHigherThanDefinedMaxHeight.value === true;
    });

    function readMoreHandleClick(event: Event) {
        isReadMoreLinkVisible.value = false;

        // Preserve from opening a module in edition mode
        event.stopPropagation();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_link = _resolveComponent("joy-link")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "readMoreContentElement",
    ref: readMoreContentElement,
    class: _normalizeClass({'read-more': isReadMoreLinkVisible.value}),
    "data-testid": `${props.dataTestid}-content`
  }, [
    (isReadMoreLinkVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_joy_link, {
            "data-testid": `${props.dataTestid}-read-more-link`,
            onClick: readMoreHandleClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.viewMoreLabel), 1)
            ]),
            _: 1
          }, 8, ["data-testid"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { class: "read-more__content" })
  ], 10, _hoisted_1))
}
}

})